// Profile data for the entity SEO page (/himabindu-rudrapaka).
export const profile = {
  name: "Himabindu Rudrapaka",
  jobTitle: "Early Childhood Education Leader & Preschool Entrepreneur",
  tagline: "Learning Innovator · Child Development Advocate · Preschool Leader",
  bioShort:
    "Himabindu Rudrapaka is an early childhood education leader and preschool entrepreneur based in Hyderabad, India, who founded and manages multiple FirstCry Intellitots Preschool & Daycare centers.",
  bio: [
    "Himabindu Rudrapaka is an early childhood education leader, edupreneur, and child-development advocate based in Hyderabad, India. With more than 15 years of experience, she has founded and manages multiple FirstCry Intellitots Preschool & Daycare centers across Hyderabad, nurturing thousands of young learners through joyful, safe, and inclusive play-based education.",
    "Her work centres on creating preschools that feel like second homes — where children learn through exploration, play, and meaningful experiences. She designs curriculum that blends literacy, numeracy, art, music, movement, and outdoor play with strong social–emotional learning, while championing teacher training and strong parent partnerships.",
    "Himabindu has represented India at the World Forum on Early Care & Education in Kuala Lumpur and has been recognised as an Outstanding Early Years Educator at Times Power Women 2026. She continues to advance early childhood education through innovative methodology, mentorship, and a deeply child-centric philosophy.",
  ],
  vision:
    "To redefine early childhood education by building nurturing, inclusive, and future-ready learning environments where every child grows into a confident, curious, and compassionate individual.",
  mission:
    "To deliver joyful, play-based, child-led learning across a trusted network of preschools — empowering children, mentoring educators, and partnering with families to build strong foundations for lifelong success.",
  leadership: [
    "Founder and director of multiple FirstCry Intellitots Preschool & Daycare centers in Hyderabad.",
    "Designs and guides play-based, experiential early-learning curricula.",
    "Leads structured teacher training, upskilling, and mentorship programs.",
    "Builds transparent parent partnerships and supportive learning communities.",
  ],
  achievements: [
    "Founded and manages multiple FirstCry Intellitots Preschool & Daycare centers across Hyderabad.",
    "Nurtured 5,000+ young learners with a team of 80+ educators.",
    "Represented India at the World Forum on Early Care & Education 2026, Kuala Lumpur.",
    "15+ years of leadership in early childhood education.",
  ],
  awards: [
    { year: "2026", title: "Outstanding Early Years Educator", org: "Times Power Women 2026, Times of India" },
    { year: "2026", title: "India Representative", org: "World Forum on Early Care & Education, Kuala Lumpur" },
    { year: "2025", title: "Progressive Edupreneur", org: "EducationWorld TREE Awards 2025–26" },
    { year: "2025", title: "Dr. Sarvepalli Radhakrishnan National Award", org: "National Education Excellence" },
    { year: "2024", title: "Outstanding Educationist of the Year", org: "Education Leadership Awards" },
    { year: "2023", title: "Top 100 Preschools of India", org: "National Education Rankings" },
  ],
  timeline: [
    { year: "2005", title: "Began journey in early childhood education (DRS Kids)" },
    { year: "2012", title: "Founded FirstCry Intellitots Nizampet" },
    { year: "2016", title: "Opened FirstCry Intellitots Botanical Garden" },
    { year: "2018", title: "Opened FirstCry Intellitots HMT Hills" },
    { year: "2020", title: "Launched online learning & training platform" },
    { year: "2024", title: "Opened FirstCry Intellitots Mayuri Nagar" },
    { year: "2026", title: "Represented India at World Forum on Early Care & Education, KL" },
    { year: "2026", title: "Honoured at Times Power Women 2026" },
  ],
  faqs: [
    {
      q: "Who is Himabindu Rudrapaka?",
      a: "Himabindu Rudrapaka is an early childhood education leader and preschool entrepreneur in Hyderabad, India, who founded and manages multiple FirstCry Intellitots Preschool & Daycare centers.",
    },
    {
      q: "Which schools does Himabindu Rudrapaka manage?",
      a: "She manages FirstCry Intellitots Preschool & Daycare centers in Nizampet, Botanical Garden (Kondapur), HMT Hills (Kukatpally), and Mayuri Nagar (Miyapur), Hyderabad.",
    },
    {
      q: "How many years of experience does Himabindu Rudrapaka have?",
      a: "She has more than 15 years of experience in early childhood education and preschool management.",
    },
    {
      q: "What awards has Himabindu Rudrapaka received?",
      a: "Her recognitions include Outstanding Early Years Educator at Times Power Women 2026, Progressive Edupreneur at EducationWorld TREE Awards, and the Dr. Sarvepalli Radhakrishnan National Award.",
    },
    {
      q: "What is Himabindu Rudrapaka's approach to early education?",
      a: "She champions joyful, play-based, child-led learning that develops children intellectually, emotionally, socially, and creatively, supported by trained educators and strong parent partnerships.",
    },
  ],
};
